var React = require('react');

function WaveAbout (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#F07A3A","fillOpacity":"1","d":"M0,64L60,96C120,128,240,192,360,192C480,192,600,128,720,85.3C840,43,960,21,1080,37.3C1200,53,1320,107,1380,133.3L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"}));
}

WaveAbout.defaultProps = {"viewBox":"0 0 1440 320"};

module.exports = WaveAbout;

WaveAbout.default = WaveAbout;
